import styled from '@emotion/styled'

export const RecurringInvoiceToggleWrapper = styled.div`
  display: flex;
  white-space: nowrap;
`
